<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, daModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="daModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <iframe
          src="https://www.youtube.com/embed/Y84ZeVCIQ5M"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          class="iframe-video"
        ></iframe>
      </div>
      <div class="project-info">
        <h1>"Dead Air" <br />Instant Empire Music Video</h1>
        <p>
          "Dead Air" by Instant Empire from the album 'Lamplight Lost',
          <br />More on Instant Empire:
          <a href="http://www.instantempireband.com/">InstantEmpireBand.com</a
          ><br />Video Directed and Filmed by Camera Speeds Inc.<br /><br />Copyright
          © Instant Empire, LLC
        </p>
        <ul class="details">
          <li><label>Client:</label>Camera Speeds Inc.</li>
          <li><label>Category:</label>Video Production</li>
          <li><label>Role:</label>Gaffer - Chief Lighting Technician</li>
          <li>
            <label>Project URL:</label
            ><a
              target="_blank"
              href="https://www.youtube.com/watch?v=Y84ZeVCIQ5M"
              ><v-icon>mdi-youtube</v-icon> View on YouTube</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>